<!-- パネルを開いている間は、後ろに半透明の黒を重ねる（検索条件の欄とパネルはその前に出す）。押すとパネルを閉じる -->
@if (selectedTabIdx !== null) {
  <div class="filter-backdrop" (click)="closePanel()"></div>
}
<div class="filter-container" #filterContainer [class.panel-open]="selectedTabIdx !== null">

  <!-- 検索条件バー -->
  <div class="search-bar">
    @if (showCondition.length === 0) {
      <span class="search-placeholder">検索条件</span>
    }

    <div class="chip-scroll">
      <div class="chip-group-row">
        @for (group of showCondition; track group.type; let gIdx = $index) {
          @for (chip of group.data; track chip.id; let first = $first; let last = $last; let cIdx = $index) {
            <div class="chip-unit" [class.margin-right]="last" [attr.data-chip-key]="group.type + '-' + chip.id">
              @if (!first) {
                <div class="chip-connector"></div>
              }
              <div class="chip">
                <span class="chip-text">{{ chip.label }}{{ chip.title }}</span>
                <button type="button" class="chip-close" aria-label="この条件を削除" (click)="onRemoveChip(gIdx, cIdx)">
                  <img src="assets/common/filter-close.svg" alt="">
                </button>
              </div>
            </div>
          }
        }
      </div>
    </div>

    @if (showCondition.length > 0) {
      <button type="button" class="clear-all-button" aria-label="すべての条件を削除" (click)="onClearAll()">
        <img src="assets/common/filter-close.svg" alt="">
      </button>
    }
  </div>

  <!-- タブナビ + パネル -->
  <div class="tab-nav-wrapper" #tabNavWrapper>
    <!-- SP（767px以下）では、見出しの並びを囲む枠ごと左右にスクロールする（PCでは何もしない） -->
    <div class="tab-nav-scroll">
    <div class="tab-nav">
      @for (tab of tabs; track tab.title; let tIdx = $index) {
        <button type="button" class="tab-item"
          [class.active]="selectedTabIdx === tIdx"
          [class.selected]="tabHasSelection(tIdx)"
          (click)="onTab(tIdx, $event)">
          <span class="tab-label-group">
            <span class="tab-label">{{ tab.title }}</span>
            <svg viewBox="0 0 24 24" width="24px" height="24px" focusable="false"><path d="M7 10l5 5 5-5z"></path></svg>
          </span>
        </button>
      }
    </div>
    </div>

    @if (selectedTabIdx !== null) {
      @switch (selectedTabIdx) {

        <!-- カテゴリー -->
        @case (0) {
          <div class="panel category-panel" [style.left.px]="panelLeft" [style.right.px]="panelRight">
            <div class="category-major-list">
              @for (major of getMaster(Constant.esMasterTypeCategoryMajor); track major.id; let mIdx = $index) {
                <!-- SP（アコーディオン）では、選択中の大分類のすぐ下に中分類を出すため order で並べる -->
                <label class="category-major-item radio-label" [style.order]="mIdx * 2"
                  [class.open]="selectedCategoryMajorId === major.id">
                  <input type="radio" name="categoryMajor"
                    [value]="major.id"
                    [checked]="selectedCategoryMajorId === major.id"
                    (click)="onCategoryMajorClick(major.id)"
                    (change)="onSelectCategoryMajor(major.id)">
                  {{ major.name }}
                </label>
              }
            </div>
            <div class="category-sub-list" [style.order]="getSelectedMajorOrder()"
              [class.is-empty]="selectedCategoryMajorId == null">
              @if (selectedCategoryMajorId == null) {
                <div class="category-sub-empty">カテゴリーを選択してください。</div>
              } @else {
                <div class="checkbox-columns">
                  @for (sub of getCategorySubMaster(); track sub.id) {
                    <mat-checkbox
                      class="thin-checkbox"
                      [disableRipple]="true"
                      [checked]="isSelected(Constant.esConditionTypeCategorySub, sub.id)"
                      (change)="onToggleCondition(Constant.esConditionTypeCategorySub, sub.id, $event.checked)">
                      {{ sub.name }}
                    </mat-checkbox>
                  }
                </div>
              }
            </div>
          </div>
        }

        <!-- 目的等 -->
        @case (1) {
          <div class="panel purpose-panel" [style.left.px]="panelLeft" [style.right.px]="panelRight">
            <div class="panel-sidenav">
              @for (nav of purposeSidenav; track nav.title; let nIdx = $index) {
                <div class="sidenav-item" [style.order]="nIdx * 2"
                  [class.active]="selectedSidenavIdx === nIdx"
                  [class.open]="selectedSidenavIdx === nIdx && !sidenavCollapsed"
                  (click)="onSidenav(nIdx)">
                  {{ nav.title }}
                  @if (sidenavHasSelection(nav.types)) {
                    <span class="selected-mark">選択中</span>
                  }
                </div>
              }
            </div>
            <div class="panel-content" [style.order]="selectedSidenavIdx * 2 + 1" [class.collapsed]="sidenavCollapsed">
              @if (selectedSidenavIdx === 0) {
                <div class="content-section">
                  <div class="checkbox-columns cols-purpose">
                    @for (item of getMaster(Constant.esMasterTypePurpose); track item.id) {
                      <mat-checkbox
                        class="thin-checkbox"
                        [disableRipple]="true"
                        [checked]="isSelected(Constant.esConditionTypePurpose, item.id)"
                        (change)="onToggleCondition(Constant.esConditionTypePurpose, item.id, $event.checked)">
                        {{ item.name }}
                      </mat-checkbox>
                    }
                  </div>
                </div>
              } @else if (selectedSidenavIdx === 1) {
                <div class="content-section">
                  <div class="checkbox-columns cols-social">
                    @for (item of getMaster(Constant.esMasterTypeSocialTheme); track item.id) {
                      <mat-checkbox
                        class="thin-checkbox"
                        [disableRipple]="true"
                        [checked]="isSelected(Constant.esConditionTypeSocialTheme, item.id)"
                        (change)="onToggleCondition(Constant.esConditionTypeSocialTheme, item.id, $event.checked)">
                        {{ item.name }}
                      </mat-checkbox>
                    }
                  </div>
                </div>
              } @else {
                <div class="content-section">
                  <div class="content-section-title">状態の変化</div>
                  <div class="checkbox-columns cols-state">
                    @for (item of getMaster(Constant.esMasterTypeImproveState); track item.id) {
                      <mat-checkbox
                        class="thin-checkbox"
                        [disableRipple]="true"
                        [checked]="isSelected(Constant.esConditionTypeImproveState, item.id)"
                        (change)="onToggleCondition(Constant.esConditionTypeImproveState, item.id, $event.checked)">
                        {{ item.name }}
                      </mat-checkbox>
                    }
                  </div>
                </div>
                <div class="content-section">
                  <div class="content-section-title">企画の成果</div>
                  <div class="checkbox-columns cols-outcome">
                    @for (item of getMaster(Constant.esMasterTypeImproveOutcome); track item.id) {
                      <mat-checkbox
                        class="thin-checkbox"
                        [disableRipple]="true"
                        [checked]="isSelected(Constant.esConditionTypeImproveOutcome, item.id)"
                        (change)="onToggleCondition(Constant.esConditionTypeImproveOutcome, item.id, $event.checked)">
                        {{ getSearchLabel(Constant.esConditionTypeImproveOutcome, item.name) }}
                      </mat-checkbox>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- 対象等 -->
        @case (2) {
          <div class="panel target-panel" [style.left.px]="panelLeft" [style.right.px]="panelRight">
            <div class="panel-sidenav">
              @for (nav of targetSidenav; track nav.title; let nIdx = $index) {
                <div class="sidenav-item" [style.order]="nIdx * 2"
                  [class.active]="selectedSidenavIdx === nIdx"
                  [class.open]="selectedSidenavIdx === nIdx && !sidenavCollapsed"
                  (click)="onSidenav(nIdx)">
                  {{ nav.title }}
                  @if (sidenavHasSelection(nav.types)) {
                    <span class="selected-mark">選択中</span>
                  }
                </div>
              }
            </div>
            <div class="panel-content" [style.order]="selectedSidenavIdx * 2 + 1" [class.collapsed]="sidenavCollapsed">
              @if (selectedSidenavIdx === 0) {
                <div class="content-section">
                  <div class="checkbox-columns">
                    @for (item of getOrganizerUnitMaster(); track item.id) {
                      <mat-checkbox
                        class="thin-checkbox"
                        [disableRipple]="true"
                        [checked]="isSelected(Constant.esConditionTypeOrganizerUnit, item.id)"
                        (change)="onToggleCondition(Constant.esConditionTypeOrganizerUnit, item.id, $event.checked)">
                        {{ item.name }}
                      </mat-checkbox>
                    }
                  </div>
                </div>
              } @else {
                <div class="content-section">
                  <div class="checkbox-columns">
                    @for (item of getMaster(Constant.esMasterTypeParticipantCategory); track item.id) {
                      <mat-checkbox
                        class="thin-checkbox"
                        [disableRipple]="true"
                        [checked]="isSelected(Constant.esConditionTypeParticipantCategory, item.id)"
                        (change)="onToggleCondition(Constant.esConditionTypeParticipantCategory, item.id, $event.checked)">
                        {{ item.name }}
                      </mat-checkbox>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- キーワード -->
        @case (3) {
          <div class="panel keyword-panel" [style.left.px]="panelLeft" [style.right.px]="panelRight">
            <div class="panel-content" [style.order]="selectedSidenavIdx * 2 + 1" [class.collapsed]="sidenavCollapsed">
              <div class="content-section">
                <div class="content-section-title">タイトル<span class="content-section-note">※{{ Constant.esKeywordMaxCount }}つまで</span></div>
                <div class="keyword-input-row">
                  <input class="keyword-input" type="text" [attr.maxlength]="Constant.esKeywordMaxLen" placeholder="検索ワードを入力"
                    [disabled]="!canAddKeyword(Constant.esConditionTypeKeywordTitle)"
                    [(ngModel)]="keywordTitleInput">
                  <button type="button" class="keyword-add-button"
                    [disabled]="!canAddKeyword(Constant.esConditionTypeKeywordTitle)"
                    (click)="addKeyword(Constant.esConditionTypeKeywordTitle)">追加</button>
                </div>
                <!-- 追加したキーワード（検索条件の欄のチップと同じ見た目。×はどちらで押しても両方から消える） -->
                @if (getKeywordChips(Constant.esConditionTypeKeywordTitle).length) {
                  <div class="keyword-chips">
                    @for (chip of getKeywordChips(Constant.esConditionTypeKeywordTitle); track $index; let cIdx = $index) {
                      <div class="chip">
                        <span class="chip-text">{{ chip.title }}</span>
                        <button type="button" class="chip-close" aria-label="この条件を削除" (click)="onRemoveKeyword(Constant.esConditionTypeKeywordTitle, cIdx)">
                          <img src="assets/common/filter-close.svg" alt="">
                        </button>
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="content-section">
                <div class="content-section-title">概要<span class="content-section-note">※{{ Constant.esKeywordMaxCount }}つまで</span></div>
                <div class="keyword-input-row">
                  <input class="keyword-input" type="text" [attr.maxlength]="Constant.esKeywordMaxLen" placeholder="検索ワードを入力"
                    [disabled]="!canAddKeyword(Constant.esConditionTypeKeywordSummary)"
                    [(ngModel)]="keywordSummaryInput">
                  <button type="button" class="keyword-add-button"
                    [disabled]="!canAddKeyword(Constant.esConditionTypeKeywordSummary)"
                    (click)="addKeyword(Constant.esConditionTypeKeywordSummary)">追加</button>
                </div>
                @if (getKeywordChips(Constant.esConditionTypeKeywordSummary).length) {
                  <div class="keyword-chips">
                    @for (chip of getKeywordChips(Constant.esConditionTypeKeywordSummary); track $index; let cIdx = $index) {
                      <div class="chip">
                        <span class="chip-text">{{ chip.title }}</span>
                        <button type="button" class="chip-close" aria-label="この条件を削除" (click)="onRemoveKeyword(Constant.esConditionTypeKeywordSummary, cIdx)">
                          <img src="assets/common/filter-close.svg" alt="">
                        </button>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <!-- 検索範囲 -->
        @case (4) {
          <div class="panel scope-panel" [style.left.px]="panelLeft" [style.right.px]="panelRight">
            <div class="panel-sidenav">
              <div class="sidenav-item active open">
                作成組織
                @if (scopeOrg) {
                  <span class="selected-mark">選択中</span>
                }
              </div>
            </div>
            <div class="panel-content" [style.order]="selectedSidenavIdx * 2 + 1" [class.collapsed]="sidenavCollapsed">
              <div class="radio-row">
                <label class="radio-label">
                  <input type="radio" name="scopeOrg"
                    [value]="Constant.esScopeOwn"
                    [checked]="scopeOrg === Constant.esScopeOwn"
                    (click)="onScopeClick(Constant.esScopeOwn)"
                    (change)="onSelectScope(Constant.esScopeOwn)">
                  自組織のみ
                </label>
                <label class="radio-label radio-label-wide">
                  <input type="radio" name="scopeOrg"
                    [value]="Constant.esScopeOther"
                    [checked]="scopeOrg === Constant.esScopeOther"
                    (click)="onScopeClick(Constant.esScopeOther)"
                    (change)="onSelectScope(Constant.esScopeOther)">
                  他組織のみ
                </label>
              </div>
            </div>
          </div>
        }
      }
    }
  </div>

</div>

  <!-- 並び替えボタン -->
  <div class="sort-section">
    <mat-form-field class="sort-button no-line" appearance="fill" subscriptSizing="dynamic">
      <mat-select
        [value]="order"
        (selectionChange)="onOrderChange($event.value)"
        disableOptionCentering="false"
        panelClass="event-search-order-select">
        <mat-select-trigger>
          <img src="assets/common/list_filter.svg" alt="" matPrefix>
          {{ selectedOrderLabel }}
        </mat-select-trigger>
        @for (opt of orderOptions; track opt.value) {
          <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>